import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  Container,
  Form,
  Navbar,
  OverlayTrigger,
  ToggleButton,
  Button,
  Tooltip,
} from "react-bootstrap";
import "../Dashboard/dashboard.css";
import "./qualityMonotoring.css";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import DetailEval from "./DetailEval";
import "./styleTable.scss";
import logoQMO from "../../assets/images/QMo.png";

import openSectionIcon from "../../assets/images/open-secion-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { activerChangeStatus, changeStyle } from "../../redux/actions/design";
import clsx from "clsx";
import plus from "../../assets/images/plus.png";
import filterCalib from "../../assets/images/filter-calib.svg";
import filterActivate from "../../assets/images/Filter-activate.svg";
import PopoverAction from "../../components/popover/PopoverAction";
import TableEval from "./TableEval";
import TableGrille from "./TableGrille";
import DetailGrille from "./DetailGrille";
import {
  getAllGrilles,
  getMesGrilles,
  searchGrilles,
  getGrillesByTenant,
  searchMesGrids,
} from "../../redux/actions/grille";
import {
  getEvalsByTenantId,
  getMesEVALs,
  searchEVALs,
  searchMesEvals,
} from "../../redux/actions/evaluation";
import PopoverActionGrille from "../../components/popover/PopoverActionGrille";
import CalibrageList from "../Calibrages/CalibragesListView/CalibrageList";
import {
  getCalibsByTenantId,
  getMesCalibs,
} from "../../redux/actions/calibrage";

import Callibrage from "../Calibrages/AddCalibrage/Callibrage";
import UpdateCalibrage from "../Calibrages/UpdateCalibrage/UpdateCalibrage";
import RingLoaderShared from "../../shared/RingLoader/RingLoader";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import iconBlocked from "../../assets/images/BlockIcon.png";
import iconCompare from "../../assets/images/noun-compare.png";
import iconDuplicate from "../../assets/images/icon-dupliquer.png";
import iconPdf from "../../assets/images/pdf-non-active.png";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Dropdown from "react-bootstrap/Dropdown";
import FilterModal from "./FilterComponent/FilterModal";
import "bootstrap/dist/css/bootstrap.min.css";
import Alert from "../../components/Alert/Alert";
const QualityMonotoring = () => {
  const [showModal, setShowModal] = useState(false);
  const { isOpen, prevPage, isOpenDetailEval, isOpenDetailGrille, statusList } =
    useSelector((state) => state.design);

  const { datacalibs } = useSelector((state) => state.calibrage);
  const { dataevals } = useSelector((state) => state.evaluation);
  const [reloadClibList, setReloadList] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const user_auth0 = JSON.parse(localStorage.getItem("user_auth0"));
  const [filterActiv, setFilterActiv] = useState(false);
  const [duplicate, setDuplicate] = useState();
  const [gridpermission, setGridpermission] = useState();
  const [calibPermission, setCalibPermission] = useState(false);
  const [evaluer, setEvaluer] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  let val = window.location.search;
  let pathChoice = val.substring(val.indexOf("=") + 1);
  const [radioValue, setRadioValue] = useState(val === "" ? "1" : pathChoice);
  const [count, setCount] = useState([]);
  const [checked, setChecked] = useState(false);
  const [showCalibSpinner, setShowCalibSpinner] = useState(false);
  const [concernedCalibId, setConcernedCalibId] = useState();
  const [nbrEvalSelections, setnbrEvalSelections] = useState(0);
  const [isGrilleEvalsSame, setIsGrilleEvalsSame] = useState(true);
  const handleConcernedCalibId = (id) => {
    setConcernedCalibId(id);
  };
  const handleRowSelectionChange = (rowsLength) => {
    setnbrEvalSelections(rowsLength);
  };
  const toggleGrilleEvals = (value) => {
    setIsGrilleEvalsSame(value);
  };

  const [evalsIdsList, setEvalsIdsList] = useState([]);
  const handleEvalsIdsList = (idsArray) => {
    setEvalsIdsList(idsArray);
  };
  //calibAlert
  const { message, status } = useSelector((state) => state.message);
  const [displayAddCalib, setDisplay] = useState("block");
  const ondisplayAddCalib = (display) => {
    setDisplay(display);
  };
  const currentPath = window.location.pathname + window.location.search;
  //calibAlert
  const { dataPermissionsByuser } = useSelector((state) => state.permissions);
  const radios = [
    { name: "Évaluations ", value: "1" },
    { name: "Grilles ", value: "2" },
  ];
  const handleCallibSpinner = () => {
    setShowCalibSpinner((prev) => !prev);
  };
  const getEvaluationstocompare = async (data) => {
    let path = `evals-compared?ids=${data}`;
    history.push(path);
  };
  const updatedRadios =
    user_auth0["http://role.tn/roles"][0] !== "AGENT"
      ? [...radios, { name: "Calibrages", value: "3" }]
      : radios;

  let isQualtyMonotoring = window.location.pathname === "/quality-monitoring";

  useEffect(() => {
    setRadioValue(val === "" ? "1" : pathChoice);
    if (window.location.pathname === "/quality-monitoring") {
      Array.from(document.getElementsByClassName("center-icon")).forEach(
        (element) => {
          element.style.visibility = "hidden";
        }
      );
      Array.from(document.getElementsByClassName("section-background")).forEach(
        (element) => {
          element.style.opacity = "1";
        }
      );
    }

    radioValue == "2"
      ? user_auth0["http://role.tn/roles"][0] === "SUPER-ADMIN"
        ? dispatch(getAllGrilles(0, 10))
        : user_auth0["http://role.tn/roles"][0] === "AGENT"
        ? dispatch(getMesGrilles(0, 10))
        : dispatch(getGrillesByTenant(0, 10))
      : fetchdata();

    dispatch(changeStyle(true, 1, "/"));
  }, [dispatch]);

  useEffect(() => {
    fetchdataCalibs();
  }, [statusList]);

  const fetchdata = () => {
    if (user_auth0["http://role.tn/roles"][0] === "ADMIN") {
      dispatch(getEvalsByTenantId(0, 10));
    } else if (user_auth0["http://role.tn/roles"][0] === "MANAGER") {
      dispatch(getMesEVALs(0, 10));
    } else if (user_auth0["http://role.tn/roles"][0] === "AGENT") {
      dispatch(getMesEVALs(0, 10));
    }
  };

  const fetchdataCalibs = () => {
    if (user_auth0["http://role.tn/roles"][0] === "ADMIN") {
      if (!statusList.length > 0) {
        dispatch(getCalibsByTenantId(0, 10));
      }
    } else if (user_auth0["http://role.tn/roles"][0] === "MANAGER") {
      if (!statusList.length > 0) {
        dispatch(getMesCalibs(0, 10));
      }
    }
  };
  const fetchGrille = async () => {
    setChecked((prevChecked) => {
      const newChecked = !prevChecked;
      dispatch(activerChangeStatus(newChecked));
      return newChecked;
    });
  };
  useEffect(() => {
    if (dataPermissionsByuser.length !== 0) {
      dataPermissionsByuser.filter((item) => item.DroitId === 56).length !== 0
        ? setDuplicate(true)
        : setDuplicate(false);
      dataPermissionsByuser?.filter((item) => item.DroitId === 57).length !== 0
        ? setGridpermission(true)
        : setGridpermission(false);
      dataPermissionsByuser?.filter((item) => item.DroitId === 58).length !== 0
        ? setCalibPermission(true)
        : setCalibPermission(false);
      dataPermissionsByuser.filter((item) => item.DroitId === 54).length !== 0
        ? setEvaluer(true)
        : setEvaluer(false);
    }
  }, [dataPermissionsByuser, duplicate, gridpermission]);

  const searchBar = (event) => {
    const keybord = event.target.value;
    const status = !checked;

    if (radioValue === "1") {
      user_auth0["http://role.tn/roles"][0] === "AGENT"
        ? dispatch(searchMesEvals(0, 10, status, keybord))
        : dispatch(searchEVALs(0, 10, status, keybord));
    }
    if (radioValue === "2") {
      user_auth0["http://role.tn/roles"][0] === "AGENT"
        ? dispatch(searchMesGrids(0, 10, status, keybord))
        : dispatch(searchGrilles(0, 10, status, keybord));
    }
  };

  function onSubmit(count) {
    setCount([...count]);
  }
  const toAddEval = (id) => {
    setCount([]);
    if (radioValue === "1") {
      let path = `add-eval`;
      history.push(path);
    } else {
      let path = `add-eval?gridId=${id}`;
      history.push(path);
    }
  };

  const toAddGrille = () => {
    setCount([]);
    let path = `add-grille`;
    history.push(path);
  };

  const [openCallibrage, setOpenCallibrage] = useState(false);
  const [openUpdateCallibrage, setUpdateOpenCallibrage] = useState(false);

  const handleOpenCallibrage = () => {
    setOpenCallibrage(true);
  };

  const handleCloseCallibrage = () => {
    setOpenCallibrage(false);
  };
  const [isArrowDown, setIsArrowDown] = useState(true);

  const handleToggleActionBtn = () => {
    setIsArrowDown(!isArrowDown);
  };
  const getTooltipText = () => {
    if (!isGrilleEvalsSame) {
      return "N'ont pas la même grille";
    } else if (nbrEvalSelections > 4) {
      return "Vous avez atteint nombre maximale";
    } else {
      return "Comparer";
    }
  };
  const popover = () => (
    <Tooltip id="tooltip-bottom-action" style={{ opacity: 1, width: "240px" }}>
      <div className="row">
        <div className="col-3 align-it">
          <OverlayTrigger
            disabled={false}
            key="bottom"
            style={{ border: 0 }}
            placement="bottom"
            overlay={
              <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                {getTooltipText()}
              </Tooltip>
            }
          >
            <div
              id="cercle-tooltip-action-disabled"
              style={{
                cursor:
                  nbrEvalSelections > 4 || !isGrilleEvalsSame
                    ? "not-allowed"
                    : "pointer",
                opacity: nbrEvalSelections > 4 ? 0.5 : 1,
              }}
              onClick={() => {
                if (nbrEvalSelections <= 4 && isGrilleEvalsSame) {
                  getEvaluationstocompare(evalsIdsList);
                }
              }}
            >
              <img
                style={{ filter: "blur(1px)" }}
                alt=""
                src={iconCompare}
                onMouseOver={(e) => (e.currentTarget.src = iconCompare)}
                onMouseOut={(e) => (e.currentTarget.src = iconCompare)}
                width="20"
                height="20"
              />
            </div>
          </OverlayTrigger>
        </div>
        <div className="col-3 align-it">
          <OverlayTrigger
            key="bottom"
            style={{ border: 0 }}
            placement="bottom"
            overlay={
              <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                dupliquer{" "}
              </Tooltip>
            }
          >
            <div
              id="cercle-tooltip-action-disabled"
              style={{ cursor: "not-allowed" }}
            >
              <img
                alt=""
                src={iconDuplicate}
                onMouseOver={(e) => (e.currentTarget.src = iconDuplicate)}
                onMouseOut={(e) => (e.currentTarget.src = iconDuplicate)}
                width="22"
                height="22"
                // onClick={
                //   user_auth0["http://role.tn/roles"][0] === "TENANT"
                //     ? dupliquer
                //     : null
                // }
              />
            </div>
          </OverlayTrigger>
        </div>
        <div className="col-3 align-it">
          <OverlayTrigger
            key="bottom"
            style={{ border: 0 }}
            placement="bottom"
            overlay={
              <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                enregister PDF{" "}
              </Tooltip>
            }
          >
            <div id="cercle-tooltip-action">
              <img
                alt=""
                src={iconPdf}
                onMouseOver={(e) => (e.currentTarget.src = iconPdfActive)}
                onMouseOut={(e) => (e.currentTarget.src = iconPdf)}
                width="22"
                height="22"
                onClick={() => handelchangeExportdetailspdf()}
              />
            </div>
          </OverlayTrigger>
        </div>
        {
          <div
            className="col3 align-it"
            onClick={() => (duplicate ? deactivate() : null)}
          >
            <OverlayTrigger
              key="bottom"
              style={{ border: 0 }}
              placement="bottom"
              overlay={
                <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                  activer / désactiver{" "}
                </Tooltip>
              }
            >
              <div
                id="cercle-tooltip-action"
                style={{ cursor: duplicate ? "pointer" : "not-allowed" }}
              >
                <img
                  alt=""
                  src={iconBlocked}
                  onMouseOver={(e) =>
                    (e.currentTarget.src = duplicate
                      ? iconBlockedActive
                      : iconBlocked)
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.src = duplicate
                      ? iconBlocked
                      : iconBlocked)
                  }
                  width="20"
                  height="20"
                />
              </div>
            </OverlayTrigger>
          </div>
        }
      </div>
    </Tooltip>
  );

  return (
    <>
      {openCallibrage && (
        <Callibrage
          openCallibrage={openCallibrage}
          closeCallibrage={handleCloseCallibrage}
          display={displayAddCalib}
          onDisplay={ondisplayAddCalib}
          reloadClibList={reloadClibList}
          setReloadList={setReloadList}
          handleCallibSpinner={handleCallibSpinner}
          showCalibSpinner={showCalibSpinner}
        />
      )}

      {openUpdateCallibrage && (
        <UpdateCalibrage
          openCallibrage={openUpdateCallibrage}
          closeCallibrage={() => setUpdateOpenCallibrage(false)}
          concernedCalibId={concernedCalibId}
          display={displayAddCalib}
          onDisplay={ondisplayAddCalib}
          reloadClibList={reloadClibList}
          setReloadList={setReloadList}
        />
      )}
      <div
        className={clsx("div-dashboard spacing-quality-monotoring", {
          "spacing-quality-monotoring-animated": isOpen && prevPage === "home",
        })}
        id="qualityMonotoring"
        data-boolean="true"
      >
        {isOpenDetailEval && Object.keys(dataevals).length !== 0 ? (
          <DetailEval />
        ) : null}
        {isOpenDetailGrille ? <DetailGrille /> : null}
        <div className="container container-dashboard emplacement-quality-monotoring row">
          <div className="section-background">
            {!isOpen ? (
              <Navbar>
                <Container>
                  <Navbar.Brand style={{ color: "#5800e2" }}>
                    <img
                      alt=""
                      src={logoQMO}
                      width="40"
                      height="40"
                      className="d-inline-block align-top"
                      style={{ marginRight: "15px" }}
                    />
                    Quality Monitoring
                  </Navbar.Brand>
                </Container>
              </Navbar>
            ) : null}

            <div id="rectangle" className="d-flex">
              <ButtonGroup className="group-btn-switch mr-auto">
                {updatedRadios.map((radio, idx) => (
                  <ToggleButton
                    className={clsx("btn-switch-quality-Monotoring", {
                      "btn-switch-active-minimize":
                        radioValue === radio.value && !isOpen,
                      "btn-switch btn-switch-active":
                        radioValue === radio.value &&
                        (isOpen || isQualtyMonotoring),
                      "btn-switch-quality-Monotoring-animated":
                        isOpen && prevPage === "home",
                    })}
                    style={{ fontFamily: "Gilroy-SemiBold" }}
                    key={idx}
                    id={`radio-${idx}`}
                    type="radio"
                    name="radio"
                    value={radio.value}
                    checked={radioValue === radio.value}
                    disabled={idx === 3}
                    onChange={(e) => {
                      setCount([]);
                      radio.value === "1"
                        ? history.push("/quality-monitoring")
                        : radio.value === "2"
                        ? history.push("/quality-monitoring?id=2")
                        : history.push("/quality-monitoring?id=3");
                      setRadioValue(e.currentTarget.value);
                      setChecked(false);
                      dispatch(activerChangeStatus(false));
                    }}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>

              {pathChoice !== "3" && (
                <Form className="d-flex search1 mr-2">
                  <input
                    type="text"
                    className="form-control input-sm"
                    style={{ height: 45 }}
                    maxLength="64"
                    placeholder="Recherche"
                    onChange={searchBar}
                  />

                  <Button
                    variant="light"
                    className="btn-search1"
                    style={{ height: 45 }}
                  >
                    <i className="fa fa-search"></i>
                  </Button>
                </Form>
              )}
              {currentPath == "/quality-monitoring" &&
                nbrEvalSelections > 1 && (
                  <>
                    <ButtonGroup
                      className="group-btn-switch-evalButton"
                      style={{ fontFamily: "Gilroy-SemiBold" }}
                    >
                      <Button className="btn-switch-quality-Monotoring-compare-eval">
                        <CheckCircleOutlineIcon />
                        <span style={{ color: "black", marginLeft: "7px" }}>
                          {nbrEvalSelections} séléctions
                        </span>
                      </Button>
                      <OverlayTrigger
                        trigger="click"
                        placement="bottom"
                        overlay={popover()}
                      >
                        <Button
                          className="btn-switch-quality-Monotoring-compare-eval-actionBtn"
                          onClick={handleToggleActionBtn}
                        >
                          Action
                          {isArrowDown ? (
                            <KeyboardArrowDownIcon />
                          ) : (
                            <KeyboardArrowUpIcon />
                          )}
                        </Button>
                      </OverlayTrigger>
                    </ButtonGroup>
                  </>
                )}

              {count.length > 0 && isOpen ? (
                radioValue === "1" ? (
                  <PopoverAction count={count} />
                ) : (
                  <PopoverActionGrille count={count} />
                )
              ) : null}

              {(radioValue === "1" && radioValue === "2") ||
              radioValue === "3" ? (
                <></>
              ) : (
                <>
                  <div className="p-2">
                    <OverlayTrigger
                      key="bottom"
                      placement="bottom"
                      overlay={
                        !checked ? (
                          <Tooltip data-color="#5800e2" id={`tooltip-bottom`}>
                            {radioValue === "2" ? (
                              <span className="desable-switch_title">
                                Grilles Activées
                              </span>
                            ) : radioValue === "3" ? (
                              <span className="desable-switch_title">
                                Calibrages actifs
                              </span>
                            ) : (
                              <span className="desable-switch_title">
                                Evaluations actives
                              </span>
                            )}
                          </Tooltip>
                        ) : (
                          <Tooltip data-color="#E30707" id={`tooltip-bottom`}>
                            {radioValue === "2" ? (
                              <span className="desable-switch_title">
                                Grilles désactivées
                              </span>
                            ) : radioValue === "3" ? (
                              <span className="desable-switch_title">
                                Calibrages inactifs
                              </span>
                            ) : (
                              <span className="desable-switch_title">
                                Evaluations désactivées
                              </span>
                            )}
                          </Tooltip>
                        )
                      }
                    >
                      <div>
                        <Switch
                          onChange={fetchGrille}
                          checked={checked}
                          className={clsx(
                            { "activate-switch-btn": checked },
                            { "deactivate-switch-btn": !checked }
                          )}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          onColor="#5800e2"
                          height={20}
                          width={38}
                        />
                      </div>
                    </OverlayTrigger>
                  </div>
                </>
              )}
              {dataPermissionsByuser.filter((item) => item.DroitId === 57)
                .length !== 0 &&
              dataPermissionsByuser.filter((item) => item.DroitId === 58)
                .length !== 0 &&
              dataPermissionsByuser.filter((item) => item.DroitId === 54)
                .length !== 0 ? (
                <div className="p-2">
                  <img
                    src={plus}
                    style={{
                      height: "45px",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                    //add permissions to access add calibrage
                    onClick={() => {
                      if (radioValue === "1") {
                        toAddEval();
                      } else if (radioValue === "2") {
                        toAddGrille();
                      } else if (radioValue === "3") {
                        handleOpenCallibrage();
                      }
                    }}
                    alt="Logo"
                  />

                  <Dropdown
                    onToggle={(isOpen) => setShowModal(isOpen)}
                    show={showModal}
                  >
                    <Dropdown.Toggle
                      variant="link"
                      id="dropdown-basic"
                      style={{
                        padding: 0,
                        border: "none",
                        backgroundColor: "transparent",
                        color: "white",
                      }}
                    >
                      <img
                        src={
                          filterActiv || sessionStorage.getItem("filterActiv")
                            ? filterActivate
                            : filterCalib
                        }
                        style={{
                          height: "45px",
                          marginRight: "10px",
                          cursor: "pointer",
                        }}
                        alt="Logo"
                      />
                    </Dropdown.Toggle>

                    {showModal && (
                      <FilterModal
                        show={showModal}
                        setFilterActiv={setFilterActiv}
                        handleClose={() => setShowModal(false)}
                      />
                    )}
                  </Dropdown>
                </div>
              ) : dataPermissionsByuser.filter((item) => item.DroitId === 54)
                  .length !== 0 && radioValue === "1" ? (
                <img
                  src={plus}
                  style={{
                    height: "45px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={toAddEval}
                  alt="Logo"
                />
              ) : dataPermissionsByuser.filter((item) => item.DroitId === 57)
                  .length !== 0 && radioValue === "2" ? (
                <img
                  src={plus}
                  style={{
                    height: "45px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={toAddGrille}
                  alt="Logo"
                />
              ) : dataPermissionsByuser.filter((item) => item.DroitId === 58)
                  .length !== 0 && radioValue === "3" ? (
                <img
                  src={plus}
                  style={{
                    height: "45px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={handleOpenCallibrage}
                  alt="Logo"
                />
              ) : (
                <></>
              )}
            </div>
            <hr className="line" />

            <div>
              {radioValue === "1" &&
              Object.keys(dataevals).length !== 0 &&
              duplicate !== undefined ? (
                <TableEval
                  onSubmit={onSubmit}
                  duplicate={duplicate}
                  setChecked={setChecked}
                  handleRowSelectionChange={handleRowSelectionChange}
                  toggleGrilleEvals={toggleGrilleEvals}
                  handleEvalsIdsList={handleEvalsIdsList}
                  setEvalsIdsList={setEvalsIdsList}
                />
              ) : null}
              {radioValue === "2" &&
              gridpermission !== undefined &&
              evaluer !== undefined ? (
                <TableGrille
                  onSubmit={onSubmit}
                  toAddEval={toAddEval}
                  haspermission={gridpermission}
                  evaluer={evaluer}
                  setChecked={setChecked}
                />
              ) : null}
              {radioValue === "3" &&
              Object.keys(datacalibs).length !== 0 &&
              duplicate !== undefined ? (
                <CalibrageList
                  onSubmit={onSubmit}
                  duplicate={duplicate}
                  setChecked={setChecked}
                  reloadClibList={reloadClibList}
                  setReloadList={setReloadList}
                  setUpdateOpenCallibrage={setUpdateOpenCallibrage}
                  handleConcernedCalibId={handleConcernedCalibId}
                  haspermission={calibPermission}
                />
              ) : null}
            </div>
          </div>
          <img
            src={openSectionIcon}
            width="40"
            height="40"
            className="center-icon"
          />
        </div>
        {message && (
          <Alert
            message={message}
            status={status === "error" ? "danger" : "success"}
            style={{ position: "fixed", bottom: 0 }}
            display={displayAddCalib}
            onDisplay={ondisplayAddCalib}
          />
        )}
        {showCalibSpinner && <RingLoaderShared></RingLoaderShared>}
      </div>
    </>
  );
};

export default QualityMonotoring;
